import React from 'react';
import PoweredBy from './PoweredBy';

const PoweredByLogo = ({ enablePublicLogo, id }) => (enablePublicLogo ? <PoweredBy id={id} /> : '');

export default PoweredByLogo;
